export default __webpack_public_path__ + "06d839552d806120526ceaf92238a380.png";